import { render, staticRenderFns } from "./management-library-risk-threat-definition-view.vue?vue&type=template&id=32ab0276"
import script from "./management-library-risk-threat-definition-view.vue?vue&type=script&lang=js"
export * from "./management-library-risk-threat-definition-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports